var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-drr',{ref:"widget",staticClass:"widget-container",style:({
    backgroundColor: _vm.backgroundColor,
    paddingLeft: (_vm.paddingLeft + "px"),
    paddingTop: (_vm.paddingTop + "px"),
    paddingRight: (_vm.paddingRight + "px"),
    paddingBottom: (_vm.paddingBottom + "px"),
    zIndex: _vm.zIndex
  }),attrs:{"parent":true,"rotatable":true,"w":_vm.w,"h":_vm.h,"x":_vm.x,"y":_vm.y,"angle":_vm.r},on:{"dragstop":_vm.dragStop,"rotatestop":_vm.rotateStop,"resizestop":_vm.resizeStop}},[_c('div',{staticClass:"widget animated bounceIn",class:{
      'align-center': _vm.verticalAlign == 'center',
      'align-end': _vm.verticalAlign == 'bottom',
      'justify-center': _vm.horizontalAlign == 'center',
      'justify-end': _vm.horizontalAlign == 'right',
    },style:({
      backgroundColor: _vm.backgroundColor,
      color: _vm.color,
      fontSize: _vm.fontSize + 'px',
    }),attrs:{"id":("widget" + _vm.id)},on:{"click":_vm.setActiveWidget}},[_vm._v("\n    "+_vm._s(_vm.hours)+":"+_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }